"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateRecurringChargesSchema = exports.updateRecurringChargeRuleSchema = exports.createRecurringChargeRuleSchema = exports.reversePackageRedemptionSchema = exports.redeemPackageItemSchema = exports.createPackageSubscriptionSchema = exports.FINANCIAL_PACKAGE_REQUEST_EXAMPLES = exports.activatePackageRequestSchema = void 0;
/**
 * Request contract for the 1 Package Billing endpoint —
 * `PackageApplicationService.activatePackage`
 * (`backend/src/modules/financial/application/package.application-service.ts`,
 * frozen, Stage 5C.3). This is the ONLY Package Billing capability
 * with an Application Service wrapper — `PackageBillingService`'s
 * `createDraftPackage`/`addItem`/`computePackagePrice` (Domain
 * Service, Stage 5C.2) have no Application Service, so no contract
 * exists for them — see `FINANCIAL-API-REVIEW.md`.
 */
const zod_1 = require("zod");
const financial_common_request_1 = require("./financial-common.request");
exports.activatePackageRequestSchema = zod_1.z.object({
    packageId: zod_1.z.string().uuid(),
    ...financial_common_request_1.financialWorkflowExtrasShape,
});
exports.FINANCIAL_PACKAGE_REQUEST_EXAMPLES = {
    activatePackage: {
        packageId: '99999999-9999-9999-9999-999999999999',
    },
};
// ---------------------------------------------------------------------------
// TD-5C2-4 — package subscriptions and the consumption ledger.
//
// Before these existed, a charge listed as INCLUDED in a package resolved to a
// price of zero with nothing counting the usage: a package covering two
// sessions covered two hundred.
// ---------------------------------------------------------------------------
exports.createPackageSubscriptionSchema = zod_1.z.object({
    packageId: zod_1.z.string().uuid(),
    patientId: zod_1.z.string().uuid(),
    invoiceId: zod_1.z.string().uuid().optional(),
    /** Back-dating a sale; defaults to now. `validUntil` is derived from this and then frozen. */
    purchasedAt: zod_1.z.coerce.date().optional(),
});
exports.redeemPackageItemSchema = zod_1.z.object({
    subscriptionId: zod_1.z.string().uuid(),
    chargeId: zod_1.z.string().uuid(),
    /** Positive only. Undoing a redemption is a reversal, not a negative redemption. */
    quantity: zod_1.z.number().int().positive().optional(),
    invoiceLineId: zod_1.z.string().uuid().optional(),
});
exports.reversePackageRedemptionSchema = zod_1.z.object({
    reason: zod_1.z.string().min(1).max(2000),
});
// ---------------------------------------------------------------------------
// ADR-047 — Recurring Charge Engine (room rent / ICU / ventilator).
// ---------------------------------------------------------------------------
exports.createRecurringChargeRuleSchema = zod_1.z.object({
    code: zod_1.z.string().min(1).max(30),
    name: zod_1.z.string().min(1).max(255),
    chargeId: zod_1.z.string().uuid(),
    frequency: zod_1.z.enum(['HOURLY', 'DAILY']),
    /** Omit to match every admission — how a blanket room-rent rule is expressed. */
    wardTypeId: zod_1.z.string().uuid().optional(),
    bedTypeId: zod_1.z.string().uuid().optional(),
    chargeOnAdmissionDay: zod_1.z.boolean().optional(),
    chargeOnDischargeDay: zod_1.z.boolean().optional(),
    /** Caps accrual so an admission never closed cannot bill indefinitely. */
    maxPeriods: zod_1.z.number().int().positive().optional(),
});
exports.updateRecurringChargeRuleSchema = exports.createRecurringChargeRuleSchema.partial().omit({ code: true, chargeId: true }).extend({
    isActive: zod_1.z.boolean().optional(),
});
exports.generateRecurringChargesSchema = zod_1.z.object({
    /** Limit to one admission — what a discharge does before raising the final bill. */
    admissionId: zod_1.z.string().uuid().optional(),
    asOf: zod_1.z.coerce.date().optional(),
});
//# sourceMappingURL=financial-package.request.js.map